// import $bridge from './JSbridge'
import Vue from 'vue'
import router from '../router'
import util from './util'
// 使用takeToken方法与客户端进行交互时，需要判断是否有用户信息，其它不需要
const payPublic = {
    takeToken(fun) {
        const _this = this
        $bridge.callHandler("jstoken", 'noNeed', (res) => {
            if (typeof(res) == "string") {
                const info = JSON.parse(res)
                _this.valInfo(fun, info)
            } else {
                _this.valInfo(fun, res)
            }
        })
    },
    valInfo(fun, info) {
        if (info.token) {
            Vue.axios.get('/api/wtcp-oauth/user/current?access_token=' + info.token).then((response) => {
                // token未失效
                if (response.data) {
                    const infoList = {
                        token: info.token,
                        userid: response.data.id,
                        mobile: response.data.mobile ? response.data.mobile : '',
                        username: response.data.username,
                        nickname: response.data.nickname ? response.data.nickname : response.data.name ? response.data.name : response.data.phone,
                        avatar: response.data.avatar
                    }
                    localStorage.setItem('userInfo', JSON.stringify(infoList))

                    if (typeof fun === "function") {

                        fun()
                    } else {
                        //不是函数
                        console.log('没执行内容！')
                    }

                } else {
                    localStorage.removeItem('userInfo')
                    this.getNewToken(fun)
                }
            }).catch(err => {
                if (err.response && err.response.data.error === "invalid_token") {
                    this.getNewToken(fun)
                }
            })
        } else { // info.token == '' 说明未登陆
            localStorage.removeItem('userInfo')
            if (typeof fun === "function") {

                fun()
            } else {
                //不是函数
                console.log('没执行内容！')
            }
        }
    },
    getNewToken(fun) {
        $bridge.callHandler("jslogin", 'noNeed', (res) => { //传参noNeed，根据返回的参数做判断
            // 若整体过期，返回空值（token: ''）
            if (typeof(res) == "string") {
                const info = JSON.parse(res)
                if (info.token) {
                    localStorage.setItem('userInfo', res)
                } else {
                    localStorage.removeItem('userInfo')
                }
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            } else {
                if (res.token) {
                    localStorage.setItem('userInfo', JSON.stringify(res))
                } else {
                    localStorage.removeItem('userInfo')
                }
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            }
        })
    },
    goLogin(fun) {
        $bridge.callHandler("jslogin", {}, (res) => {
            if (res == 'noLogin') {
                localStorage.setItem('noLogin', res)
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            } else {
                localStorage.removeItem('noLogin')
                if (typeof(res) == "string") {
                    localStorage.setItem('userInfo', res)
                    if (typeof fun === "function") {
                        fun()
                    } else {
                        //不是函数
                        console.log('没执行内容！')
                    }
                } else {
                    localStorage.setItem('userInfo', JSON.stringify(res))
                    if (typeof fun === "function") {
                        fun()
                    } else {
                        //不是函数
                        console.log('没执行内容！')
                    }
                }
            }
        })
    },

    toToken(fun) {
        const _this = this
        $bridge.callHandler("jstoken", {}, (res) => {
            if (res == 'noLogin') {
                localStorage.setItem('noLogin', res)
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            } else {
                localStorage.removeItem('noLogin')
                if (typeof(res) == "string") {

                    const info = JSON.parse(res)
                    _this.appInfo(fun, info)

                } else {
                    _this.appInfo(fun, res)
                }
            }
        })
    },
    appInfo(fun, info) {
        const _this = this
        Vue.axios.get('/api/wtcp-oauth/user/current?access_token=' + info.token).then((response) => {
            // token未失效
            if (response.data) {
                const infoList = {
                    token: info.token,
                    userid: response.data.id,
                    mobile: response.data.mobile ? response.data.mobile : '',
                    username: response.data.username,
                    nickname: response.data.nickname ? response.data.nickname : response.data.name ? response.data.name : response.data.phone,
                    avatar: response.data.avatar
                }
                localStorage.setItem('userInfo', JSON.stringify(infoList))

                if (typeof fun === "function") {

                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }

            } else {
                localStorage.removeItem('userInfo')
                _this.goLogin(fun)
            }
        }).catch(err => {
            if (err.response && err.response.data.error === "invalid_token") {
                localStorage.removeItem('userInfo')
                _this.goLogin(fun)
            }
        })
    },

    hasToken(fun) {
        const _this = this
        $bridge.callHandler("jstoken", {}, (res) => {
            if (typeof(res) == "string") {
                const info = JSON.parse(res)
                _this.hasInfo(fun, info)

            } else {
                _this.hasInfo(fun, res)
            }
        })
    },
    hasInfo(fun, info) {
        const _this = this
        Vue.axios.get('/api/wtcp-oauth/user/current?access_token=' + info.token).then((response) => {
            // token未失效
            if (response.data) {
                const infoList = {
                    token: info.token,
                    userid: response.data.id,
                    mobile: response.data.mobile ? response.data.mobile : '',
                    username: response.data.username,
                    nickname: response.data.nickname ? response.data.nickname : response.data.name ? response.data.name : response.data.phone,
                    avatar: response.data.avatar
                }
                localStorage.setItem('userInfo', JSON.stringify(infoList))

                if (typeof fun === "function") {

                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }

            } else {
                localStorage.removeItem('userInfo')
                _this.refToken(fun)
            }
        }).catch(err => {
            if (err.response && err.response.data.error === "invalid_token") {
                _this.refToken(fun)
            }
        })
    },
    refToken(fun) {
        $bridge.callHandler("jslogin", {}, (res) => {
            if (res == 'noLogin') {
                localStorage.setItem('noLogin', res)
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            } else {
                localStorage.removeItem('noLogin')
                if (typeof(res) == "string") {
                    localStorage.setItem('userInfo', res)
                    if (typeof fun === "function") {
                        fun()
                    } else {
                        //不是函数
                        console.log('没执行内容！')
                    }
                } else {
                    localStorage.setItem('userInfo', JSON.stringify(res))
                    if (typeof fun === "function") {
                        fun()
                    } else {
                        //不是函数
                        console.log('没执行内容！')
                    }
                }
            }
        })
    },

    callPhone(phone) {
        if (this.isClient()) {
            let phoneNum = JSON.stringify({
                phone: phone
            })
            $bridge.callHandler("jsphone", phoneNum, (res) => {})
        } else {
            window.location.href = 'tel://' + phone
        }
    },
    getUrl(kind) {
        $bridge.callHandler("jsurl", kind, (res) => {})
    },
    navigation(data) {
        const param = JSON.stringify(data)
        $bridge.callHandler("jsnavigation", param, (res) => {})
    },
    goBack() {
        $bridge.callHandler("jsgoback", {}, (res) => {})
    },
    goHome() {
        $bridge.callHandler("jsgohome", {}, (res) => {})
    },
    // 打开小程序
    goMini(data) {
        const param = JSON.stringify(data)
        $bridge.callHandler("jsgomini", param, (res) => {})
    },

    sharePage(data) {
        // url，title，image，desc
        const param = JSON.stringify(data)
        $bridge.callHandler("jsshare", param, (res) => {})
    },
    // 判断是否登录
    checkLogin(fun) {
        if (this.isClient()) {
            this.takeToken(() => {
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            })
        } else {
            this.loginCheck(function() {
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            }, true)
        }
    },
    // 点击收藏如果未登录则跳转登录
    toLogin(fun) {
        if (this.isClient()) {
            this.goLogin(function() {
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            })
        } else {
            this.getUserInfo(function() {
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            })
        }
    },

    // 判断页面打开的环境
    isClient() {
        const ua = navigator.userAgent.toLowerCase()
        // android_client 安卓、 xyhl_ios ios
        if(ua.match(/android_client/i) == "android_client"){
            return 2
        }else if(ua.match(/xyhl_ios/i) == "xyhl_ios"){
            return 1
        }else {
            return false
        }
    },

    /**
     * h5登录验证
     * @param fun 登陆后的执行方法
     * @param noLogin 未登录是否去登录
     */
    loginCheck(fun, noLogin) {
        const _this = this
        const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
        if (userInfo) {
            Vue.axios.get('/api/wtcp-oauth/user/current?access_token=' + userInfo.access_token).then((response) => {
                userInfo.nickname = response.data.nickname
                userInfo.avatar = response.data.avatar
                localStorage.setItem('userInfo', JSON.stringify(userInfo))
                // token未失效
                if (response.data) {
                    localStorage.removeItem('my_redirect_url')
                    if (typeof fun === "function") {
                        fun()
                    } else {
                        //不是函数
                        console.log('没执行内容！')
                    }
                } else {
                    // 更新token
                    _this.refreshH5Token(userInfo, fun, noLogin)
                }
            }).catch(err => {
                if (err.response && err.response.data.error === "invalid_token") {
                    // 更新token
                    _this.refreshH5Token(userInfo, fun, noLogin)
                }
            })
        } else {
            // router.push('/login')
            if (!noLogin) {
                _this.getUserInfo(fun)
            } else {
                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }
            }
        }
    },
    refreshH5Token(userInfo, fun, noLogin) {
        const _this = this

        Vue.axios.post('/api/wtcp-oauth/refreshToken?auth_type=public&refreshToken=' + userInfo.refresh_token + '&userId=' + userInfo.user.id).then((response) => {
            if (response.data.user) {
                userInfo.token = response.data.access_token
                userInfo.refresh_token = response.data.refresh_token
                localStorage.setItem('userInfo', JSON.stringify(userInfo))

                if (typeof fun === "function") {
                    fun()
                } else {
                    //不是函数
                    console.log('没执行内容！')
                }

                localStorage.removeItem('my_redirect_url')
            } else {
                localStorage.removeItem('userInfo')
                    // router.push('/login')
                if (!noLogin) {
                    _this.getUserInfo(fun)
                } else {
                    if (typeof fun === "function") {
                        fun()
                    } else {
                        //不是函数
                        console.log('没执行内容！')
                    }
                }
            }
        })
    },
    getUserInfo(fun) {
        const wxInfo = localStorage.getItem('wxUserInfo') ? JSON.parse(localStorage.getItem('wxUserInfo')) : ''
        if (wxInfo) {
            // 根据微信unionId微信账号是否绑定
            Vue.axios.get('/api/wtcp-oauth/wx/userRelation/' + wxInfo.unionid + '?deptCode=' + Vue.prototype.DEPT_CODE.DEPTCODE).then((response) => {
                const resData = response.data
                const wxBindState = resData
                if (wxBindState.status === 1) {
                    if (wxBindState.data.access_token) {
                        let user = wxBindState.data.user || {}
                        let userInfoBase = {
                            avatar: user.avatar,
                            mobile: user.mobile,
                            nickname: user.nickname,
                            token: wxBindState.data.access_token,
                            userid: user.id,
                            username: user.username,
                            refresh_token: wxBindState.data.refresh_token
                        }
                        localStorage.setItem('userInfo', JSON.stringify(userInfoBase))

                        if (typeof fun === "function") {
                            fun()
                        } else {
                            //不是函数
                            console.log('没执行内容！')
                        }
                    } else {
                        router.push('/relation')
                    }
                } else {
                    // 没有绑定手机号
                    router.push('/relation')
                }
            })
        } else {
            router.push('/login')
        }
    },
    // alert框
    showPrompt(msg, fun) {
        if (this.isClient()) {
            alert(msg)
            if (typeof fun === "function") {
                fun()
            } 
        } else {
            let promot = Vue.extend({
                data() {
                    return {
                        isShow: true
                    };
                },
                template: `<transition name="prompt">
                    <div class="xyly-prompt-layout" v-if="isShow">
                        <div class="prompt-box">
                            <h5>温馨提示</h5>
                            <p>${msg}</p>
                            <div class="prompt-btn">
                                <div class="ensure" @click="onHide">知道了</div>
                            </div>
                        </div>
                    </div>
                </transition>`,
                methods: {
                    onHide() {
                        this.isShow = false
                        if (typeof fun === "function") {
                            fun()
                        }
                    }
                },
            })
            document.body.appendChild((new promot().$mount()).$el)
        }
    },
    // 商品浏览记录保存
    recordSaved(record,info){

        record.address = returnCitySN.cname,
        record.browseNum = 1, 
        record.commodityBrowseNum = 1,
        record.ip = returnCitySN.cip, 
        record.source = this.isClient() ? 1 : (util.isWeiXin() ? 2 : 3),  // 浏览来源:1-app 2-h5 3-web
        record.commodityVisitor = info ? info.mobile : '',
        record.visitor = info ? info.mobile : ''

        Vue.axios.post('/api/wtcp-ecrm/public/commodityBrowseRecord/createOrUpdate', record).then((response) => {})
    }
}
export default payPublic
